import { useState, useEffect } from "react";
import { offerEmd } from "@/api/placeOffer";
import { trackButtonClick } from "@/utils/analytics";

const OfferAmount = ({
  listingOfferDetails,
  accordionState,
  listingId,
  offerPricingInformation,
  sellerParameters,
  bidAmount,
  setBidAmount,
  setOfferDetails,
  setCurrentOfferAmountDetails,
  setSellerConcession,
  offerDetails,
  currentOfferAmountDetail,
  setAccordionState,
  offerType
}) => {
  const {
    minimumStartingOffer: minStartingOffer,
    maximumPermissibleOffer: maxPermissibleOffer,
    technologyFeesFormatted,
  } = listingOfferDetails || {};

  const BID_INCREMENT = 1000;
  const INITIAL_CONCESSION = {
    id: 1,
    type: "",
    amount: null,
    note: "",
    desc: "",
  };

  const [isEditMode, setIsEditMode] = useState(false);
  const [amountError, setAmountError] = useState("");
  const [totalDues, setTotalDues] = useState(
    offerPricingInformation?.totalDuesFormatted
  );
  const [holdOfferCheck, setHoldOfferCheck] = useState(true);
  const [backupOffer, setBackupOffer] = useState(
    sellerParameters?.defaultBackUpOfferDays
  );
  const [sellerConcessionRequest, setSellerConcessionRequest] = useState([
    INITIAL_CONCESSION,
  ]);
  const [errors, setErrors] = useState({});

  const [offerAmountBlur, setOfferAmountBlur] = useState(true);
  const [disable, setDisable] = useState({ inc: false, dec: false });
  const [focusedAmountId, setFocusedAmountId] = useState(null)
  const [loading,setLoading] = useState(false)

  const totalSellerConcession = sellerConcessionRequest.reduce(
    (sum, item) => sum + (Number.parseInt(item.amount) || 0),
    0
  );

  useEffect(() => {
    setBidAmount(offerPricingInformation?.offerAmount || 0);
    setTotalDues(offerPricingInformation?.totalDuesFormatted);
    setBackupOffer(sellerParameters?.defaultBackUpOfferDays);
  }, [offerPricingInformation]);

  const handleBidChange = async (newAmount) => {
    try {
      const data = await offerEmd({ listingId, amount: newAmount });
      setTotalDues(data?.totalDuesFormatted);
    } catch (error) {
      console.error("Error updating bid:", error);
    }
  };

  const updateDisableButtons = (value) => {
    const numericValue = Number(value);
    if (numericValue <= minStartingOffer) {
      setDisable({ dec: true, inc: false });
    } else if (numericValue >= maxPermissibleOffer) {
      setDisable({ dec: false, inc: true });
    } else {
      setDisable({ dec: false, inc: false });
    }
  };

  const increaseOfferAmount = () => {
    setOfferAmountBlur(false);

    const currentAmount = Number(bidAmount);
    const newAmount = currentAmount + BID_INCREMENT;
    setBidAmount(newAmount);
    validateOfferAmount(newAmount);
    handleBidChange(newAmount);
    updateDisableButtons(newAmount);

    setOfferAmountBlur(true);
  };

  const decreaseOfferAmount = () => {
    setOfferAmountBlur(false);

    const currentAmount = Number(bidAmount);
    const newAmount = currentAmount - BID_INCREMENT;

    setBidAmount(newAmount);
    validateOfferAmount(newAmount);
    handleBidChange(newAmount);
    updateDisableButtons(newAmount);
    setOfferAmountBlur(true);
  };

  const handleOfferAmountChange = (e) => {
    const value = e.target.value;
    setBidAmount(value);

    const numericValue = Number(value);
    if (!isNaN(numericValue)) {
      validateOfferAmount(numericValue);
      updateDisableButtons(numericValue);
    } else {
      setDisable({ dec: false, inc: false });
    }
  };

  const validateOfferAmount = (value) => {
    if (value < minStartingOffer) {
      setAmountError(
        `Your offer must be at least ${listingOfferDetails?.minimumStartingOfferFormatted}`
      );
    } else if (value > maxPermissibleOffer) {
      setAmountError(
        `Your offer can't exceed ${listingOfferDetails?.maximumPermissibleOfferFormatted}`
      );
    } else {
      setAmountError("");
    }
  };

  const addSellerConcession = () => {
    if(sellerConcessionRequest?.length<=8){
      setSellerConcessionRequest((prev) => [
        ...prev,
        { ...INITIAL_CONCESSION, id: prev[prev.length - 1].id + 1 },
      ]);
    }
  };

  const deleteSellerConcession = (id) => {
    if (sellerConcessionRequest.length > 1) {
      setSellerConcessionRequest((prev) =>
        prev.filter((item) => item.id !== id)
      );
      clearSellerConcessionData(id)
    }
  };

  const clearSellerConcessionData = (id) => {
    setSellerConcessionRequest((prev) =>
      prev.map((item) =>
        item.id === id ? { ...INITIAL_CONCESSION, id: item.id } : item
      )
    );

    setErrors((prev) => {
      const newErrors = { ...prev };
        if (newErrors.total) {
       delete newErrors?.total;
      delete newErrors?.totalAdd
    }
      delete newErrors?.totalAdd
      delete newErrors[id];
      return newErrors;
    });
  };

  const handleSellerConcessionChange = (e, id) => {
    const { name, value } = e.target;
    const cleanedValue = name === "amount" ? value.replace(/[^0-9]/g, "") : value;

  setSellerConcessionRequest((prev) => {
    const updated = prev.map((item) => {
      if (item.id === id) {
        if (name === "type") {
          const selectedContribution =
            sellerParameters?.sellerContributionList?.find(
              (item) => item.sellerContributionId === value
            );
          return {
            ...item,
            [name]: value,
            desc: selectedContribution?.sellerContributionDesc || "",
          };
        }
        return { ...item, [name]: cleanedValue };
      }
      return item;
    });

    // Re-validate amount when type changes using updated state
    if (name === "type") {
      const updatedItem = updated.find(item => item.id === id);
       if (updatedItem?.amount) {
        setTimeout(() => validateField("amount", updatedItem.amount, id, updatedItem), 0);
      }
    }

    return updated;
  });

    validateField(name, cleanedValue, id);
  };


  const validateField = (name, value, id,itemOverride = null) => {
    clearError(id, name);
    console.log('iniiiii',name,value);

     // Note validation: only required if type === 'OTH'
if (name === "note") {
  const trimmedNote = value?.trim() || "";
  const item = itemOverride || sellerConcessionRequest.find((item) => item.id === id);

  const MIN_LENGTH = 2;
  const MAX_LENGTH = 500;
  const disallowedPattern = /[^a-zA-Z0-9\s.,'-]/;
  if (item?.type === "OTH" && !trimmedNote) {
    setErrors((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        note: "Note Required",
      },
    }));
    return;
  }
  if (trimmedNote) {
    if (trimmedNote.length < MIN_LENGTH) {
      setErrors((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          note: `Note must be at least ${MIN_LENGTH} characters.`,
        },
      }));
      return;
    }

    if (trimmedNote.length > MAX_LENGTH) {
      setErrors((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          note: `Note must not exceed ${MAX_LENGTH} characters.`,
        },
      }));
      return;
    }

    if (disallowedPattern.test(trimmedNote)) {
      setErrors((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          note: "Note contains invalid characters.",
        },
      }));
      return;
    }
  }
  return;
}

  if (!value) {
    setErrors((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [name]: name === "amount" ? "Amount invalid" : "Select Type",
      },
    }));
    return;
  }
    if (name === "amount") {
      const item = itemOverride || sellerConcessionRequest.find((item) => item.id === id);
        const numericValue = Number(value);
console.log(item.desc,'descc');

      if (
        item.desc === "Repair Cost Credit" &&
        numericValue > sellerParameters?.allowedMaximumRepairCost
      ) {
        setErrors((prev) => ({
          ...prev,
          [id]: {
            ...prev[id],
            amount: "Invalid Amount",
          },
             totalAdd:`The seller has indicated a maximum repair cost credit of ${formatAmountToDollars(sellerParameters?.allowedMaximumRepairCost)}.`
        }));
      } else if (
        item.desc === "Closing Cost Credit" &&
        numericValue > sellerParameters?.allowedMaximumClosingCost
      ) {
        setErrors((prev) => ({
          ...prev,
          [id]: {
            ...prev[id],
            amount:"Invalid Amount",
          },
          totalAdd:`The seller has indicated a maximum closing cost credit of ${formatAmountToDollars(sellerParameters?.allowedMaximumClosingCost)}.`
        }));
      }else{
        if(numericValue>Number(bidAmount)){
           setErrors((prev) => ({
          ...prev,
          [id]: {
            ...prev[id],
            amount:"Invalid Amount",
          },
          total:"Your concession amount can't exceed your offer amount."
        }));
        }
        else if(Number(value) === 0){
            setErrors((prev) => ({
          ...prev,
          [id]: {
            ...prev[id],
            amount:"Amount Invalid",
          },
        }));
        } else {
      clearError(id, 'amount');
    }
      }
    }
  };

  const clearError = (id, field) => {
    setErrors((prev) => {
      const newErrors = { ...prev };
    //     if (newErrors.total || newErrors?.totalAdd) {
    //   delete newErrors?.total;
    //   delete newErrors?.totalAdd
    //   return newErrors;
    // }
     if (field === 'amount' && (newErrors.total || newErrors?.totalAdd)) {
      delete newErrors?.total;
      delete newErrors?.totalAdd;
    }

      if (newErrors[id]) {
        delete newErrors[id][field];
        if (Object.keys(newErrors[id]).length === 0) {
          delete newErrors[id];
        }
      }
      return newErrors;
    });
  };
  const formatAmountToDollars = (amount) => {
    if (!amount && amount !== 0) return "";
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount);
  };

const handleContinue = () => {
  const updatedErrors = {};
  const multipleRows = sellerConcessionRequest.length > 1;
  setLoading(true)


  const isRowEmpty = (row) => !row.type?.trim() && !row.amount;
  const isRowComplete = (row) => row.type?.trim() && row.amount;

  const anyRowFilled = sellerConcessionRequest.some((row) => !isRowEmpty(row));
  const allRowsComplete = sellerConcessionRequest.every(isRowComplete);

  sellerConcessionRequest.forEach((item) => {
    const rowErrors = {};
    const hasAnyValue = item.type?.trim() || item.amount;

    if (hasAnyValue) {
      if (!item.type?.trim()) rowErrors.type = "Select Type";
      if (!item.amount || Number(item.amount) === 0) rowErrors.amount = "Amount invalid";

      if (item.type === "OTH" && !item.note?.trim()) {
        rowErrors.note = "Note Required";
      }

      if (Object.keys(rowErrors).length > 0) {
        updatedErrors[item.id] = rowErrors;
      }
    }
  });

  const combinedErrors = { ...errors, ...updatedErrors };

  if (Object.keys(combinedErrors).some((key) => Object.keys(combinedErrors[key] || {}).length > 0)) {
    setErrors(combinedErrors);
    setLoading(false)
    return;
  }

  setErrors({});

  const formatCurrency = (number) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
    }).format(number);

  setCurrentOfferAmountDetails({
    ...currentOfferAmountDetail,
    offerAmount: bidAmount,
    totalDuesFormatted: formatCurrency(totalDues),
    technologyFeesFormatted: technologyFeesFormatted,
    totalSellerContribution: totalSellerConcession,
  });

  setOfferDetails({
    ...offerDetails,
    isBackupOfferSelected: holdOfferCheck,
    backupOfferDaysSelected: holdOfferCheck?backupOffer?.toString():null,
  });

  const hasValidData = sellerConcessionRequest.some(
    (item) => item.type && Number(item.amount) > 0
  );
  setSellerConcession(hasValidData ? sellerConcessionRequest : []);
  setLoading(false)
  setAccordionState({
    ...accordionState,
    accordion1: { disable: false, close: true, edit: true },
    accordion2: { close: false, disable: false, edit: false },
  });

  trackButtonClick({
    eventName: "offer_options_next",
    eventSource: "Continue Button Click",
    eventCategory: "New-Offer Wizard",
    eventLabel: `Listing Id: ${listingId}`,
    eventParams: {
      offer_type: offerType === "PLACE_OFFER" ? "offer" : "backup_offer",
    },
  });
};

const handleKeyDown = (e) =>   {
    const allowedKeys = [
      "Backspace", "ArrowLeft", "ArrowRight", "Tab", "Delete"
    ];
    if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const renderSellerConcessionRow = (data) =>{
      const selectedTypes = sellerConcessionRequest
    .filter((item) => item.id !== data.id)
    .map((item) => item.type)
    .filter(Boolean);
    return(
    <tr key={data.id} className="text-start">
      <td className="text-start">
        <select
          name="type"
          className={`select h-25 ${
            errors[data.id]?.type ? "border-error" : ""
          }`}
          value={data.type || ""}
          onChange={(e) => handleSellerConcessionChange(e, data.id)}
          onBlur={(e) => validateField(e.target.name, e.target.value, data.id)}
        >
          <option value="">Select</option>
          {/* {sellerParameters?.sellerContributionList?.map((item) => (
            <option key={item.sellerContributionId} value={item.sellerContributionId}>
              {item.sellerContributionDesc}
            </option>
          ))} */}
          {sellerParameters?.sellerContributionList
            ?.slice()
            .sort((a, b) => {
              // Push "OTH" to the end
              if (a.sellerContributionId === "OTH") return 1;
              if (b.sellerContributionId === "OTH") return -1;
              return 0;
            }).filter(
              (item) =>
                !selectedTypes.includes(item.sellerContributionId) ||
                item.sellerContributionId === data.type
            )
            .map((item) => (
              <option
                key={item.sellerContributionId}
                value={item.sellerContributionId}
              >
                {item.sellerContributionDesc}
              </option>
            ))}
        </select>
        {errors[data.id]?.type && (
          <div className="error-offer">{errors[data.id].type}</div>
        )}
      </td>
      <td className="text-start">
        <input
          type="text"
          value={focusedAmountId === data.id ? data.amount : formatAmountToDollars(data.amount)}
          name="amount"
          aria-label="amount"
          className={`form-control h-25 w-100 ${
            errors[data.id]?.amount ? "border-error" : ""
          }`}
          placeholder="Amount ?"
          onChange={(e) => handleSellerConcessionChange(e, data.id)}
          onBlur={(e) => {setFocusedAmountId(null);validateField(e.target.name, e.target.value, data.id)}}
          onKeyDown={handleKeyDown}
          onFocus={() => setFocusedAmountId(data.id)}
        />

        {errors[data.id]?.amount && (
          <div className="error-offer">{errors[data.id].amount}</div>
        )}
      </td>
      <td>
        <div className="d-flex gap-2">
          <input
            type="text"
            value={data.note || ""}
            name="note"
            aria-label="note"
            className={`form-control w-75 h-25 ${
              errors[data.id]?.note ? "border-error" : ""
            }`}
            placeholder="Enter Note"
            onChange={(e) => handleSellerConcessionChange(e, data.id)}
            onBlur={(e) =>
              validateField(e.target.name, e.target.value, data.id)
            }
          />
          <button
            className="edit btn-sm btn"
            onClick={() => clearSellerConcessionData(data.id)}
          >
            Clear
          </button>
          {sellerConcessionRequest.length > 1 && (
            <button
              className="btn btn-sm edit"
              onClick={() => deleteSellerConcession(data.id)}
            >
              Delete
            </button>
          )}
        </div>
        {errors[data.id]?.note && (
          <div className="error-offer text-start">{errors[data.id].note}</div>
        )}
      </td>
    </tr>
  )};

  const renderSummaryView = () => (
    <div className="offer-amount-edit-div container">
      <div className="row">
        <div className="col">
          <p className="edit-offer-amount-title">Your Offer Amount</p>
          <p className="edit-offer-amount">
            {bidAmount?.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 0,
            })}
          </p>
        </div>
        <div className="col">
          <p className="edit-offer-amount-title">Technology Fee</p>
          <p className="edit-offer-amount">{technologyFeesFormatted}</p>
        </div>
        <div className="col borderLeft">
          <p className="edit-offer-amount-title">Total Due</p>
          <p className="edit-offer-amount fs18">{totalDues || 0}</p>
        </div>
      </div>
    </div>
  );

  const renderDetailedView = () => (
    <div className="accordion-body">
      <div className="offer-amount">
        <div className="your-offer">
          <p className="offer-amount-title">Your Offer Amount</p>
          {isEditMode ? (
            <div>
              <div className="flex">
                <button
                  disabled={
                    disable.dec || Number(bidAmount) === minStartingOffer
                  }
                  onClick={decreaseOfferAmount}
                  className="btn btn-sm incdec-button"
                >
                  -
                </button>
                <input
                  type="text"
                  value={
                    offerAmountBlur
                      ? formatAmountToDollars(bidAmount)
                      : bidAmount
                  }
                  name="bidAmount"
                  onChange={handleOfferAmountChange}
                  className="form form-control h-25 w-50 input-bid-offer"
                  onBlur={() => {setOfferAmountBlur(true);handleBidChange(bidAmount)}}
                  onFocus={() => setOfferAmountBlur(false)}
                />
                <button
                  disabled={disable.inc}
                  onClick={increaseOfferAmount}
                  className="btn btn-sm incdec-button"
                >
                  +
                </button>
              </div>
              {amountError && <p className="error-offer">{amountError}</p>}
            </div>
          ) : (
            <>
              <span className="offer-amount">
                {offerPricingInformation?.offerAmountFormatted === "$0"
                  ? minStartingOffer
                  : offerPricingInformation?.offerAmountFormatted}
              </span>
              <button
                className="btn btn-sm edit"
                onClick={() => setIsEditMode(true)}
              >
                <i className="fa fa-pencil"> </i> Edit
              </button>
            </>
          )}
        </div>

        <div className="technology-fee">
          <p className="offer-amount-title pt-2">
            Technology Fee
            {/* <div
              className="cursor-pointer d-inline-block mb-0 info-tooltip-offer"
              data-toggle="tooltip"
              data-placement="top"
              title="Paid by the buyer at closing and added to the purchase price of the property, this fee covers the costs of Hubzu's technology platform and related services."
            >
              i
            </div> */}
            <div className="tooltip-container">
  <span className="info-tooltip-offer">i</span>
  <div className="tooltip-text">Paid by the buyer at closing and added to the purchase price of the property, this fee covers the costs of Hubzu's technology platform and related services.</div>
</div>


          </p>
          <p className="offer-amount">{technologyFeesFormatted}</p>
        </div>

        <div className="total-due-offer">
          <p className="offer-amount-title">
            Total Due
            {/* <div
              className="cursor-pointer d-inline-block mb-0 info-tooltip-offer"
              data-toggle="tooltip"
              data-placement="top"
              title="The sum of the offer amount plus fees."
            >
              i
            </div> */}
             <div className="tooltip-container">
  <span className="info-tooltip-offer">i</span>
  <div className="tooltip-text">The sum of the offer amount plus fees.</div>
</div>
          </p>
          <p className="offer-amount">{totalDues || 0}</p>
        </div>

        <div className="hold-backup-offer">
          <input
            type="checkbox"
            name="holdbackupoffer"
            id="holdbackupoffer"
            className="form-check-input check-box"
            aria-label="holdbackupoffer"
            checked={holdOfferCheck}
            disabled={offerType==="PLACE_BACKUP_OFFER"}
            onChange={(e) => setHoldOfferCheck(e.target.checked)}
          />
          <p className="hold-backup-offer-label">
            Hold my offer as a backup for{" "}
          </p>
          <select
            name="backupoffer"
            className="select"
            disabled={!holdOfferCheck}
            value={backupOffer || ""}
            onChange={(e) => setBackupOffer(e.target.value)}
          >
            {sellerParameters?.daysToConsiderForBackUpOffer?.map((day) => (
              <option
                key={day}
                value={day}
                defaultValue={sellerParameters?.defaultBackUpOfferDays}
              >
                {day} days
              </option>
            ))}
          </select>
        </div>

        <div className="seller-concession">
          <h6>Seller Concession Request</h6>
          <div className="table-responsive seller-concess-table">
            <table className="table border">
              <thead className="thead-dark">
                <tr>
                  <th className=" text-left">Type</th>
                  <th className="w-15">
                    Amount{" "}
                    {/* <div
                      className="cursor-pointer d-inline-block mb-0 info-tooltip-offer"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Buyer ('Buyer Agent') requests the Seller shall pay up to the dollar amount referenced in the Amount field. Note:  fewer concessions will make your offer more attractive to the Seller."
                    >
                      i
                    </div> */}
                    <div className="tooltip-container">
  <span className="info-tooltip-offer">i</span>
  <div className="tooltip-text">Buyer ('Buyer Agent') requests the Seller shall pay up to the dollar amount referenced in the Amount field. Note:  fewer concessions will make your offer more attractive to the Seller.</div>
</div>
                  </th>
                  <th colSpan={2} className="w-75">
                    Note
                  </th>
                </tr>
              </thead>
              <tbody>
                {sellerConcessionRequest.map(renderSellerConcessionRow)}
              </tbody>
            </table>
          </div>
          <div className="d-flex">
          <button className="add-another btn" onClick={addSellerConcession}>
            + Add Another
          </button>
          {errors?.totalAdd && <p className="error-offer pl20 mb-0 pt-1">{errors?.totalAdd}</p>}
          </div>
          <div className="total-seller">
            <p>
              Total Seller Concession{" "}
              {/* <div
                className="cursor-pointer d-inline-block mb-0 info-tooltip-offer"
                data-toggle="tooltip"
                data-placement="top"
                title={`Buyer ("Buyer Agent") requests Seller pay up to the dollar amount shown in the Amount($) field. Note: fewer concessions will make your offer more attractive to the Seller`}
              >
                i
              </div> */}
               <div className="tooltip-container">
  <span className="info-tooltip-offer">i</span>
  <div className="tooltip-text">Buyer ("Buyer Agent") requests Seller pay up to the dollar amount shown in the Amount($) field. Note: fewer concessions will make your offer more attractive to the Seller</div>
</div>
            </p>
            <span>{formatAmountToDollars(totalSellerConcession)}</span>
             {errors?.total && <p className="error-offer pl20 mb-0 pt-1 fw-normal">{errors?.total}</p>}
          </div>
        </div>
      </div>

      <button
        className="continue-offer btn hubzu-btn-thm"
        onClick={handleContinue}
      >
        {
          loading?"Continue...":"Continue"
        }
      </button>
    </div>
  );

  return (
    <div className="accordion-item mb-2 border rounded">
      <h2
        className="accordion-header p-1 font-weight-bold"
        id="flush-heading-offeramount"
      >
        <button
          className={`accordion-button ${
            accordionState?.accordion1?.close ? "collapsed" : ""
          } ${
            accordionState?.accordion1?.close &&
            accordionState?.accordion1?.edit
              ? "no-caret"
              : ""
          }
          `}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#flush-collapse-offeramount"
          aria-expanded="false"
          aria-controls="flush-collapse-offeramount"
        >
          <div className="d-flex w-100 justify-content-between align-items-center">
            <p className="d-flex align-items-center mb-0 offer-acc-title">
              {" "}
              <p className="accordion-number mb-0">1</p> Offer Amount{" "}
            </p>
            {accordionState?.accordion1?.edit && (
              <div>
                <button
                  className="edit-accordion-offer"
                  onClick={() =>
                    setAccordionState({
                      ...accordionState,
                      accordion1: {
                        ...accordionState.accordion1,
                        edit: false,
                        close: false,
                      },
                      accordion2: { ...accordionState.accordion2, close: true },
                      accordion3: { ...accordionState.accordion3, close: true },
                    })
                  }
                >
                  <i className="fa fa-pencil"></i> Edit
                </button>
              </div>
            )}
          </div>
        </button>
      </h2>

      {accordionState?.accordion1?.edit ? (
        renderSummaryView()
      ) : (
        <div
          id="flush-collapse-offeramount"
          className={`accordion-collapse collapse ${
            accordionState?.accordion1?.close ? "" : "show"
          }`}
          aria-labelledby="flush-heading-offeramount"
          data-bs-parent="#accordionFlushExample"
        >
          {renderDetailedView()}
        </div>
      )}
    </div>
  );
};

export default OfferAmount;
